import React from "react";
import { Form } from "react-formio";
import { notification } from "antd";
import { executeIntent } from "../../../../experience/utils/IntentExecutor";
import IntentType from "../../../../intentexecutor/utils/IntentType";
import "./publicformrenderer.css";

const PublicFormRenderer = ({
  formTemplateData,
  formSubmitCallback,
  formTitle,
}) => {
  const showErrorMessage = () => {
    notification.error({
      message: "Something went wrong while submitting form",
      placement: "bottomRight",
    });
  };

  const submitUserResponse = async (userResponse) => {
    try {
      const payload = {
        data: {
          formData: userResponse.data,
          formName: formTitle,
          status: "Filled",
        },
      };
      const formDataResponse = await executeIntent(
        IntentType.ADD_PUBLIC_FORMDATA,
        payload,
      );
      if (formDataResponse?.identifier) {
        formSubmitCallback(formDataResponse);
      } else {
        showErrorMessage();
      }
    } catch (err) {
      showErrorMessage();
    }
  };

  return (
    <div className="public-form">
      <Form form={formTemplateData} onSubmit={submitUserResponse} />
    </div>
  );
};

export default PublicFormRenderer;
